export const timelineData = [
  {
    year: 1963,
    title: "The Enchanted Tiki Room",
    description: "The debut of Disneyland's tiki birds, marking the first use of animatronics in a theme park attraction."
  },
  {
    year: 1964,
    title: "Great Moments with Mr. Lincoln",
    description: "Abraham Lincoln animatronic debuts at the New York World's Fair, showcasing Disney's innovation in realistic robotic performances."
  },
  {
    year: 1967,
    title: "Pirates of the Caribbean",
    description: "This iconic Disneyland attraction sets a benchmark for scenic integration and lifelike robotic performances, featuring scurvy pirates and wenches."
  },
  {
    year: 1969,
    title: "Haunted Mansion",
    description: "Disneyland's Haunted Mansion opens, merging animatronics with illusions like Pepper's Ghost to create eerily convincing ghosts."
  },
  {
    year: 1977,
    title: "Chuck E. Cheese's Pizza Time Theatre",
    description: "The first interactive entertainment restaurant for families features an animatronic band, paving the way for animatronics in dining experiences."
  },
  {
    year: 1982,
    title: "The American Adventure",
    description: "Ben Franklin animatronic at EPCOT becomes the first figure to give the illusion of walking up stairs."
  },
  {
    year: "1980s",
    title: "King Kong and T-Rex",
    description: "Universal Studios introduces groundbreaking animatronics, including the original King Kong and T-Rex figures."
  },
  {
    year: 2003,
    title: "Lucky the Dinosaur",
    description: "Disney's first free-roaming animatronic figure amazes guests with its lifelike interactions and mobility."
  },
  {
    year: 2008,
    title: "Mr. Potato Head",
    description: "This interactive animatronic debuts at Disney's Toy Story Midway Mania!, engaging guests with its humor and interactivity."
  },
  {
    year: 2017,
    title: "Shaman of Songs",
    description: "Introduced in Pandora–The World of Avatar at Disney's Animal Kingdom, this animatronic is hailed as one of the most advanced and fluid ever created."
  },
  {
    year: 2018,
    title: "King Kong in Skull Island: Reign of Kong",
    description: "Universal debuts a new King Kong animatronic at Islands of Adventure, adding lifelike motion and detail to the attraction."
  },
  {
    year: 2019,
    title: "Star Wars: Galaxy's Edge",
    description: "High-profile animatronics such as Kylo Ren and interactive Stormtroopers bring the Star Wars universe to life at Disneyland and Disney's Hollywood Studios."
  },
  {
    year: "2020s",
    title: "Disney's Stuntronics Project",
    description: "Robotic figures capable of performing complex aerial maneuvers redefine animatronics in live entertainment."
  },
  {
    year: 2021,
    title: "Super Nintendo World",
    description: "Universal's immersive land features animatronics like Piranha Plants and Goombas, creating a dynamic and alive-feeling environment."
  }
];